export default __webpack_public_path__ + "static/pragicts-automation-services-backup-recovery-c0e37d6837c5d2a23d1ac9e568621e46.jpg";